<!-- <button *ngIf="!visible" (click)="getDetails()">Get Details</button> -->
<ng-container id="üstMenü">
  <div *ngIf="visible" style="font-size: 18px">
    <ng-container *ngFor="let item of inventionDetailData; let i = index">
      <b>
        <ng-container>Buluş Adı: {{ inventionName }}</ng-container></b
      >
    </ng-container>
  </div>
  <div *ngIf="visible">
    <ng-container *ngFor="let item of inventionDetailData; let i = index">
      Dosya No:{{ item.documentNumber }}
    </ng-container>
  </div>
  <div *ngIf="visible">
    <ng-container *ngFor="let item of inventionDetailData; let i = index">
      Dosya Durumu: {{ item.status[item.status.length - 1].status }}
    </ng-container>
  </div>
</ng-container>
<button class="btn" (click)="navigate()">Üst Menüye Git</button>
<br />

<p></p>
<div>
  <div class="row">
    <div *ngIf="visible" class="column">
      <span>Kaydedilecek Data:</span>
      <p></p>

      <table style="width: 80%">
        <tr>
          <td style="width: 20%">
            <strong for="documentNumber">Dosya No:</strong>
          </td>
          <td>
            <input
              [(ngModel)]="documentNumber"
              (ngModelChange)="documentNumber= $event.toLowerCase()"
              type="text"

              id="documentNumber"
              placeholder="{{ documentNumber }}"
              style="width: 80%"

            />
          </td>
        </tr>

        <tr>
          <td style="width: 20%">
            <strong for="inventionName">Buluş Adı:</strong>
          </td>
          <td>
            <input
              [(ngModel)]="inventionName"
              (ngModelChange)="inventionName= $event.toLowerCase()"
              type="text"
              id="inventionName"
              placeholder="{{ inventionName }}"
              style="width: 80%"
            />
          </td>
        </tr>

        <tr>
          <td style="width: 20%">
            <strong for="inventionDate">Buluş Tarihi:</strong>
          </td>
          <td>
            <input
              [(ngModel)]="inventionDate"
              type="date"
              id="inventionDate"
              placeholder="{{ inventionDate }}"
              style="width: 80%"
            />
          </td>
        </tr>
      </table>
      <hr />

      <span for="inventors">Başvuru Sahipleri:</span>
      <p></p>
      <button type="button" class="btn" (click)="findCompany()">
        {{
          visibleCompany
            ? "Başvuru Sahibi Listesini Sakla"
            : "Başvuru Sahibi Listesini Göster"
        }}
      </button>
      <button
        type="button"
        id="add"
        class="btn"
        (click)="deleteCompanies()"
        style="background-color: #d70040"
      >
        Başvuru Sahibileri Sil
      </button>
      <p></p>
      <h2 *ngIf="record">{{ record }}</h2>

      <table>
        <thead>
          <th>#</th>
          <th>Başvuru Sahibi Adı</th>
          <!-- <th>Başvuru Sahibi Adresi</th> -->
          <!-- <th>Başvuru Sahibi Kurum No</th> -->
          <th></th>
        </thead>
        <tbody>
          <tr *ngFor="let user of company; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ user.name }}</td>
            <!-- <td>{{ user.adress }}</td> -->
            <!-- <td>{{ user.identity }}</td> -->
            <td>
              <button
                type="button"
                id="add"
                class="btn"
                (click)="findCompany()"
              >
                Daha Fazla Başvuru Sahibi Ekle
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <hr />
      <ng-container
        class="form-row"
        *ngFor="let user of companyData; let i = index"
        style="margin-left: 3%"
      >
        <table>
          <tr>
            <td>
              <strong for="companyData">{{ user.name }}'in payı (1-100)</strong>
            </td>
            <td>
              <input
                [(ngModel)]="companyData[i].share"
                type="number"
                id="companyData"
                placeholder="Share Percentage {{ user.share }}"
                style="width: 80%"
              />
            </td>
          </tr>
        </table>
      </ng-container>
      <hr />
      <br />
      <!-- <form [formGroup]="inventionRecord" (ngSubmit)="onSubmit()"> -->

      <hr />

      <br />
      <span for="inventors">Vekil Bilgileri:</span>
      <p></p>
      <button type="button" class="btn" (click)="findAttorney()">
        {{
          visibleAttorney ? "Vekil Listesini Sakla" : "Vekil Listesini Göster"
        }}
      </button>
      <button
        type="button"
        id="add"
        class="btn"
        (click)="deleteAttornies()"
        style="background-color: #d70040"
      >
        Vekil Kayıtlarını Sil
      </button>
      <p></p>
      <h2 *ngIf="record">{{ record }}</h2>

      <table>
        <thead>
          <th>#</th>
          <th>Vekil Adı</th>
          <!-- <th>Başvuru Sahibi Adresi</th> -->
          <!-- <th>Başvuru Sahibi Kurum No</th> -->
          <th></th>
        </thead>
        <tbody>
          <tr *ngFor="let user of attorney; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ user.name }}</td>
            <!-- <td>{{ user.adress }}</td> -->
            <!-- <td>{{ user.identity }}</td> -->
            <td>
              <button
                type="button"
                id="add"
                class="btn"
                (click)="findAttorney()"
              >
                Daha Fazla Vekil Kaydı Ekle
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <span for="inventors">Buluş Sahipleri:</span>
      <p></p>
      <button type="button" class="btn" (click)="findInventor()">
        {{
          visibleInventor
            ? "Buluş Sahibi Listesini Gizle"
            : "Buluş Sahibi Listesini Göster"
        }}
      </button>
      <button
        type="button"
        id="add"
        class="btn"
        (click)="deleteInventors()"
        style="background-color: #d70040"
      >
        Buluş Sahiplerini Sil
      </button>
      <p></p>
      <h2 *ngIf="record">{{ record }}</h2>

      <table>
        <thead>
          <th>#</th>
          <th>Buluş Sahibi Adı/Soyadı</th>
          <!-- <th>Buluş Sahibi Adresi</th>
          <th>Buluş Sahibi e-postası</th>
          <th>Buluş Sahibi Kimlik No</th>
          <th>Buluş Sahibi Durumu</th> -->
          <th></th>
        </thead>
        <tbody>
          <tr *ngFor="let user of inventor; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ user.name }}</td>
            <!-- <td>{{ user.adress }}</td>
            <td>{{ user.mail }}</td>
            <td>{{ user.identity }}</td>
            <td>{{ user.status }}</td> -->
            <td>
              <button
                type="button"
                id="add"
                class="btn"
                (click)="findInventor()"
              >
                Daha Fazla Buluş Sahibi Ekle
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <hr />
      <ng-container
        class="form-row"
        *ngFor="let user of inventorData; let i = index"
      >
        <table>
          <tr>
            <td>
              <strong for="inventorData"
                >{{ user.name }}'in payı (1-100)</strong
              >
            </td>
            <td>
              <input
                [(ngModel)]="inventorData[i].share"
                type="number"
                id="inventorData"
                placeholder="Share Percentage {{ user.share }}"
              />
            </td>
          </tr>
        </table>
      </ng-container>
      <hr />
      <table>
        <tr>
          <td>
            <label for="status"><strong>Buluş Durumu:</strong> </label>
            <select
              name="status"
              [(ngModel)]="status"
              id="status"
            >
              <option value="karar:buluş iptal edildi.">karar:Buluş iptal edildi.</option>
              <option value="karar:buluş hakları buluş sahibine verildi.">	karar:Buluş hakları Buluş SAHİBİNE verildi.</option>
              <option value="karar:buluş hakları şirkete verildi">karar:Buluş hakları ŞİRKETE verildi.</option>
              <option value="karar:buluş gizli tutulacaktır.">karar:Buluş gizli tutulacaktır.</option>
              <option value="taslak buluş">Taslak Buluş</option>
              <option value="kabul edilmiş buluş">Kabul Edilmiş Buluş</option>
            </select></td></tr></table>
      <hr />
      <br />
      <!-- <button type="button" (click)="onCheck()" class="btn btn-warning">
        Kontrol Et
      </button> -->

      <button
        *ngIf="checkValidity()"
        (click)="onSubmit()"
        class="btn"
        style="
          margin-left: auto;
          margin-right: 10%;
          font-size: 18px;
          display: block;
          background-color: #28384f;
        "
      >
        Buluşu Kaydet
      </button>

      <!-- <button
        type="button"
        (click)="onSubmitEmail()"
        class="btn btn-success"
        [disabled]="!aslan"
      >
        Buluşu Kaydet ve Buluş Sahiplerine e-posta Gönder
      </button> -->
    </div>

    <div
      *ngIf="(visibleCompany || visibleInventor || visibleAttorney) && !error"
      class="column"
    >
      <h2 *ngIf="visibleInventor && !error">Sisteme Kayıtlı Buluş Sahipleri</h2>
      <p *ngIf="error">
        {{ error }} Kayıt ve internet durumunuzu kontrol ediniz.
      </p>
      <input
        *ngIf="visibleInventor && !error"
        class="form-control"
        class="icon"
        type="text"
        name="search"
        [(ngModel)]="searchText"
        (ngModelChange)="searchText=$event.toLowerCase()"
        autocomplete="off"
        placeholder="Buluş Sahibi bilgileri üzerinden arama yapabilirsiniz"
        id="input1"
      />

      <table *ngIf="visibleInventor" style="table-layout: fixed; width: 100%">
        <thead>
          <th style="word-wrap: break-word">#</th>
          <th style="word-wrap: break-word">Buluş Sahibi Adı/Soyadı</th>
          <!-- <th>Buluş Sahibi Adresi</th>
          <th>Buluş Sahibi e-postası</th>
          <th>Buluş Sahibi Kimlik No</th>
          <th>Buluş Sahibi Durumu</th> -->
          <th style="word-wrap: break-word"></th>
        </thead>
        <tbody>
          <tr *ngFor="let user of users; let i = index">
            <ng-container *ngFor="let item of user | filter: searchText">
              <td>{{ i + 1 }}</td>
              <td>{{ item.inventorName }}</td>
              <!-- <td>{{ item.inventorAdress }}</td>
              <td>{{ item.inventorMail }}</td>
              <td>{{ item.inventorIdentityNo }}</td>
              <td>{{ item.inventorStatus }}</td> -->
              <td>
                <button
                  type="button"
                  id="add"
                  class="btn btn-primary"
                  (click)="getInventor(i)"
                  style="word-wrap: break-word"
                >
                  Buluş Sahibi Ekle
                </button>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
      <h2 *ngIf="visibleCompany && !error">Kayıtlı Başvuru Sahibiler</h2>
      <h2 *ngIf="error">
        {{ error }} Kayıt ve internet durumunuzu kontrol ediniz.
      </h2>
      <input
        *ngIf="visibleCompany && !error"
        class="form-control"
        class="icon"
        type="text"
        name="search"
        [(ngModel)]="searchText"
        (ngModelChange)="searchText= $event.toLowerCase()"
        autocomplete="off"
        placeholder="Başvuru Sahibi adı adresi veya numarası üzerinden arama yapabilirsiniz"
        id="input1"
      />
      <table *ngIf="visibleCompany" style="table-layout: fixed; width: 100%">
        <thead>
          <th style="width: 4%; word-wrap: break-word">#</th>
          <th style="width: 73%; word-wrap: break-word">Başvuru Sahibi Adı</th>
          <!-- <th style="width: 25%; word-wrap: break-word">Başvuru Sahibi Adresi</th> -->
          <!-- <th style="width: 23%; word-wrap: break-word">Başvuru Sahibi Kurum No</th> -->
          <th style="width: 23%"></th>
        </thead>
        <tbody>
          <tr *ngFor="let user of companies; let i = index">
            <ng-container *ngFor="let item of user | filter: searchText">
              <td style="width: 4%; word-wrap: break-word">{{ i + 1 }}</td>
              <td style="width: 90%; word-wrap: break-word">
                {{ item.CompanyName }}
              </td>
              <!-- <td style="width: 25%; word-wrap: break-word">
                {{ item.CompanyAdress }}
              </td>
              <td style="width: 23%; word-wrap: break-word">
                {{ item.CompanyIdentityNo }}
              </td> -->
              <td style="width: 6%; word-wrap: break-word">
                <button
                  type="button"
                  id="add"
                  class="btn"
                  (click)="getCompany(i)"
                >
                  Başvuru Sahibi Ekle
                </button>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
      <h2 *ngIf="visibleAttorney && !error">Kayıtlı Vekiller</h2>
      <h2 *ngIf="error">
        {{ error }} Kayıt ve internet durumunuzu kontrol ediniz.
      </h2>
      <input
        *ngIf="visibleAttorney && !error"
        class="form-control"
        class="icon"
        type="text"
        name="search"
        [(ngModel)]="searchText"
        (ngModelChange)="searchText= $event.toLowerCase()"
        autocomplete="off"
        placeholder="Vekil adı adresi veya numarası üzerinden arama yapabilirsiniz"
        id="input1"
      />
      <table *ngIf="visibleAttorney" style="table-layout: fixed; width: 100%">
        <thead>
          <th style="width: 4%; word-wrap: break-word">#</th>
          <th style="width: 73%; word-wrap: break-word">Vekil Adı</th>
          <!-- <th style="width: 25%; word-wrap: break-word">Başvuru Sahibi Adresi</th> -->
          <!-- <th style="width: 23%; word-wrap: break-word">Başvuru Sahibi Kurum No</th> -->
          <th style="width: 23%"></th>
        </thead>
        <tbody>
          <tr *ngFor="let user of attornies; let i = index">
            <ng-container *ngFor="let item of user | filter: searchText">
              <td style="width: 4%; word-wrap: break-word">{{ i + 1 }}</td>
              <td style="width: 90%; word-wrap: break-word">
                {{ item.AttorneyName }}
              </td>
              <!-- <td style="width: 25%; word-wrap: break-word">
                {{ item.CompanyAdress }}
              </td>
              <td style="width: 23%; word-wrap: break-word">
                {{ item.CompanyIdentityNo }}
              </td> -->
              <td style="width: 6%; word-wrap: break-word">
                <button
                  type="button"
                  id="add"
                  class="btn"
                  (click)="getAttorney(i)"
                >
                  Vekil Ekle
                </button>
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="visible" class="column">
      <!-- <span>Raw Data</span>
    <div>
      <label>Document No:</label>
      <p></p>
      <ol *ngFor="let item of inventionDetailData; let i = index">
        <div>{{ item.documentNumber }}</div>
      </ol>
    </div>

    <div>
      <p>
        <label>Invention Name:</label>
      </p>

      <p></p>
      <ol *ngFor="let item of inventionDetailData; let i = index">
        <div>{{ item.inventionName }}</div>
      </ol>
    </div>

    <div>
      <p>
        <label>Invention Date:</label>
      </p>

      <p></p>
      <ol *ngFor="let item of inventionDetailData; let i = index">
        <div>{{ item.inventionDate }}</div>
      </ol>
    </div>

    <div>
      <p>
        <label>Invention Status:</label>
      </p>

      <p></p>
      <ol *ngFor="let item of inventionDetailData; let i = index">
        <div>{{ status }}</div>
      </ol>
    </div>

    <div>
      <p>
        <label>Company Details:</label>
      </p>

      <p></p>

      <ol *ngFor="let item of companyData; let i = index">
        <div>Company Name:{{ item.name }}</div>
        <p></p>
        <div>Company ID:{{ item.identity }}</div>
        <p></p>
        <div>Company Adress:{{ item.adress }}</div>
        <p></p>
        <div>Company Share:{{ item.share }}</div>
      </ol>
    </div>

    <div>
      <p>
        <label>Inventor Details:</label>
      </p>

      <p></p>

      <ol *ngFor="let item of inventorData; let i = index">
        <div style="color: red">{{ i + 1 }}.Inventor</div>
        <p></p>
        <div>Inventor Name:{{ item.name }}</div>
        <p></p>
        <div>Inventor Adress:{{ item.adress }}</div>
        <p></p>
        <div>Inventor Mail:{{ item.mail }}</div>
        <p></p>
        <div>Inventor ID:{{ item.identity }}</div>
        <p></p>
        <div>Inventor Share:{{ item.share }}</div>
        <p></p>
      </ol>
    </div> -->
    </div>
  </div>
</div>
<h1>{{ error }}</h1>
